import { createSelector, MemoizedSelector } from '@ngrx/store';
import { entityDataSelector } from 'army-builder-shared/src/lib/global/state/entity-reducer';

import { FWWLibraryState } from './state';
import { EntityLibraryState } from 'army-builder-shared/src/lib/global/army-builder-entity-store';
import { GAME_IDS } from '../../game-id.token';

export const selectFWW: MemoizedSelector<FWWLibraryState, FWWLibraryState> = createSelector(
    entityDataSelector,
    (s: EntityLibraryState) => s.data[GAME_IDS.FWW] as FWWLibraryState
);

export const FWW_SELECTORS = {
    factions: createSelector(selectFWW, (s) => s?.['factions']?.data),
    unitTemplates: createSelector(selectFWW, (s) => s?.['unit-templates']?.data),
    behaviors: createSelector(selectFWW, (s) => s?.['behaviors']?.data),
    explores: createSelector(selectFWW, (s) => s?.['explores']?.data),
    strangers: createSelector(selectFWW, (s) => s?.['strangers']?.data),
    dangers: createSelector(selectFWW, (s) => s?.['dangers']?.data),
    creatures: createSelector(selectFWW, (s) => s?.['creatures']?.data),
    quests: createSelector(selectFWW, (s) => s?.['quests']?.data),
    boosts: createSelector(selectFWW, (s) => s?.['boosts']?.data),
    events: createSelector(selectFWW, (s) => s?.['events']?.data),
    environments: createSelector(selectFWW, (s) => s?.['environments']?.data),
    purposes: createSelector(selectFWW, (s) => s?.['purposes']?.data),
    battlefields: createSelector(selectFWW, (s) => s?.['battlefields']?.data),
    referenceCards: createSelector(selectFWW, (s) => s?.['reference-cards']?.data),
    equipment: createSelector(selectFWW, (s) => s?.['equipment']?.data),
    automatrons: createSelector(selectFWW, (s) => s?.['automatrons']?.data),
    perks: createSelector(selectFWW, (s) => s?.['perks']?.data),
    leaders: createSelector(selectFWW, (s) => s?.['leaders']?.data)
};
